export const workflowLogExecutionContexts = (state) => state.monitoring.workflowLogExecutionContexts;

export const workflowLogExecutionContextById = (state, workflowLogId) => workflowLogExecutionContexts(state)?.[workflowLogId];
